import React from 'react';
import noop from 'lodash/noop';
import { func } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon';
import Close from 'yoda-core-components/lib/assets/svg/CloseIcon_2022.svg';
import Button from 'yoda-core-components/lib/components/Button/Button';

const CMCouponPanelHeader = (props) => {
    return (
        <div
            className={dt([
                'flex',
                'justify-end',
                'border-b',
                'border-solid',
                'h-12',
                'border-gray-15',
                'relative',
                'z-10',
                'bg-white',
                'top-0',
            ])}
            data-automation-id="at-slider-header"
        >
            <Button
                buttonId="panelHeaderCloseIcon"
                buttonType="Text"
                className={dt(['mr-4'])}
                onClick={props?.onClosePanel}
            >
                <Icon
                    automationId="at-ydt-bopis-store-icon"
                    iconType="svg"
                    width="28px"
                    height="28px"
                    viewBox="0 0 28 28"
                >
                    <Close />
                </Icon>
            </Button>
        </div>
    );
};

CMCouponPanelHeader.defaultProps = {
    onClosePanel: noop,
};

CMCouponPanelHeader.propTypes = {
    onClosePanel: func,
};

export default CMCouponPanelHeader;
